import { Injectable } from '@angular/core';
import { RestApiService } from '../services/rest-api.service';
import { Observable } from 'rxjs';

@Injectable()
export class UserCommonService {
  notificationText: any = 'Notifications';
  isNotifications: any;

  constructor(private restApiService: RestApiService) { }
  signOut(): Observable<any> {
    return this.restApiService.delete('/secure/signout', 'page-center');
  }

  // signIn(data): Observable<any> {
  //   return this.restApiService.post('/signin', data, 'page-center');
  // }

  signIn(data): Observable<any> {
    return this.restApiService.post('/user-signin', data, 'page-center');
  }

  shibbolethSign(data): Observable<any> {
    return this.restApiService.post('/users/signin', data, 'page-center')
  }

  v1signIn(data): Observable<any> {
    return this.restApiService.v1post('/signin', data, 'page-center');
  }

  passwordChange(data, userId): Observable<any> {
    return this.restApiService.put(`/secure/users/${userId}/profile/password`, data, 'page-center');
  }

  setPassword(data): Observable<any> {
    return this.restApiService.post('/users/set-password', data, 'page-center');
  }

  getUserProfile(userId): Observable<any> {
    return this.restApiService.get(`/secure/users/${userId}/profile`, 'page-center');
  }

  getV1UserProfile(userId): Observable<any> {
    return this.restApiService.v1get(`/secure/users/${userId}/profile`, 'page-center');
  }

  updateUserProfile(data, userId): Observable<any> {
    return this.restApiService.patch(`/secure/users/${userId}/profile`, data, 'page-center');
  }

  forgotPassword(data): Observable<any> {
    return this.restApiService.post('/users/forgot-password', data, 'page-center');
  }

  validateOtp(data): Observable<any> {
    return this.restApiService.post('/users/verify-otp', data, 'page-center');
  }

  getServiceAreaId(): Observable<any> {
    return this.restApiService.get('/secure/tenants/servicearea', 'page-center');
  }

  resendEmailVerificationLink(id, type): Observable<any> {
    return this.restApiService.post(`/secure/email-phonenum-verification?userId=${id}&verificationType=${type}`, 'page-center');
  }

  getPrivacyPolicy(): Observable<any> {
    return this.restApiService.get('/tenant-privacy-policy', 'page-center');
  }

  getUserDetail(clientSystemId): Observable<any> {
    return this.restApiService.get(`/secure/users/${clientSystemId}/userinfo`, 'page-center');
  }

  getMetadata(): Observable<any> {
    return this.restApiService
      .get(`/admin/metadata`, 'page-center');
  }
}

